import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon'

const FlagMexico = (props) => (
  <SvgIcon viewBox="0 0 640 480" {...props}>
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="#fff" d="M0 0h639.984v480H0z" />
      <path fill="#0b7226" d="M0 0h214.301v480H0z" />
      <path fill="#bc0000" d="M426.91 0h213.074v480H426.909z" />
    </g>
    <path
      d="M213.125 258.71c.077-.1 3.468-6.038 3.066-5.081 1.562 1.197 4.415.063 2.345-2.63.504-1.089 1.14-1.919 1.643-3.008 1.138-2.132-1.299-3.05-2.263-1.576-.59 1.128-1.159 1.8-1.748 2.929-3.071-1.458-3.273 1.97-1.804 2.57-.652.922-1.762 2.443-2.413 3.366.39 1.143.783 2.286 1.174 3.43z"
      fillRule="evenodd"
      fill="#9c4314"
    />
    <path
      d="M212.722 257.388c-.101-.075-6.086-3.382-5.124-2.994 1.175-1.579 0-4.415-2.662-2.307-1.096-.489-1.936-1.113-3.032-1.601-2.147-1.107-3.03 1.342-1.544 2.285 1.138.574 1.816 1.133 2.954 1.707-1.414 3.09 2.017 3.244 2.595 1.767.932.639 4.544 2.732 5.476 3.37 1.137-.406.2-1.82 1.337-2.227zM234.369 293.669c.02-.124.174-6.96.276-5.928 1.943.309 3.911-2.047.809-3.429-.076-1.197.088-2.23.012-3.428-.014-2.416-2.595-2.063-2.74-.308.019 1.274-.162 2.135-.143 3.409-3.394.18-1.939 3.291-.361 3.118-.134 1.122-.386 2.988-.52 4.11l2.667 2.456z"
      fillRule="evenodd"
      fill="#9c4314"
    />
    <path
      d="M233.384 292.694c-.124-.018-6.961-.075-5.93-.192.28-1.948-2.103-3.882-3.44-.76-1.197.092-2.232-.057-3.429.036-2.415.049-2.025 2.624-.269 2.745 1.274-.038 2.137.13 3.41.093.23 3.392 3.32 1.892 3.124.318l5.756.602c.806-.9-.027-1.942.778-2.842z"
      fillRule="evenodd"
      fill="#9c4314"
    />
    <path
      d="M304.128 316.122s2.345 3.166 3.4 3.283c3.283.234 29.312 0 29.312 0 0-.04.938-.547.938-.586.86-1.095.782-1.72 1.642-2.815 1.368-1.367 3.322-1.797 4.69-3.165 5.862-1.407 11.138-2.814 17.001-3.752-.469-3.478-3.986-2.736-5.862-4.104-.586-.547-.47-1.094-.118-1.641l13.015-5.98v-1.407c-9.224 1.094-17.744 2.892-27.671 3.283L306.59 313.19l-2.462 2.931z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.99}
      fill="#42b2f3"
    />
    <path
      d="M210.444 253.863h-.118c.588 0 .12.039 0-1.408"
      stroke="#000"
      strokeWidth={0.5278124999999999}
      fill="none"
    />
    <path
      d={`M210.95 255.428c-1.759-6.214-4.6-11.66-11.233-13.27-1.244-.282-2.127-3.834-.055-3.668 1.173.469.024-.223 1.196.246 1.161.415 2.968-.5 2.222-2.476 0-.235-2.213-4.164-2.213-4.281-.415-.45.355-2.969 2.345-1.642.938.616 1.876 2.06 3.228 2.345.498-.083.827-1.627.744-2.823 0-.117.117-4.052.117-4.052-.471-2.371 1.627-3.582 3.311-1.807.118.586-.013.592.104 1.178.386.785.855.907 1.406.117l2.228-2.228c1.323-.491 2.149-.983 2.228 1.76 0 0-1.825 2.287-2.688 3.116-.45.663-1.424 1.565.269 2.062.117 0 2.419.332 2.419.332 1.575.655 1.741 2.388.58 2.545 0 0-1.228 1.433-3.383 2.628-.663.532-1.21 1.173-.629 1.904 1.244.484.848.02 2.969.02 1.79-.414 1.624 3.969-1.61 3.672-.967.231-2.244.135-2.768 1.682-.235 1.204-.293 3.517-.293 4.103-.2 2.79.21 6.662.21 6.779.234 1.993-.47 1.29-.704 1.758zM230.14 291.185c-.228-.292-6.104-6.73-12.89-6.007-1.267.153-3.298-2.892-1.29-3.436 1.261.046.279-.134 1.54-.088 1.067-.749-.862-3.051-1.733-2.252-.079-.22-2.327.482-3.28.288-2.949-.283-4.237-3.578-2.083-4.828 1.34.512 3.873.56 5.243.37 1.353-.412.726-1.644-.585-1.828-1.866-.276-9.395-2.11-8.73-3.024-1.244-2.073-.01-3.671 2.175-2.57 1.803 1.093 2.013.48 1.574-.336-.534-1.55-1.048-1.179-1.126-2.524-.133-.867.148-1.65 1.427-1.106.54-.454 1.427 2.792 4.78 1.561.62.519 1.147-3.512 3.473-2.898 1.744.54.553 2.352.893 4.912.28 1.686 1.964 1.299 2.195.423-.364-3.873 3.422-3.941 3.855-2.632.36.956.683 3.562.225 6.012-.249 1.245-.051 3.716.742 4.21 1.334.034.473-.268 1.39-1.648 1.545-.994 3.947 2.606 1.136 4.414-2.966.64 1.68 11.938 2.072 12.57-.43.462-.94-.104-1.003.417z`}
      fillRule="evenodd"
      stroke="#286726"
      strokeWidth={1.8309375}
      fill="#008d00"
    />
    <path
      d="M266.563 321.4c0-.126-.92-6.901-.656-5.897 1.968 0 3.542-2.635.262-3.514-.262-1.17-.263-2.216-.525-3.387-.393-2.384-2.887-1.632-2.755.125.218 1.255.175 2.133.393 3.388-3.324.71-1.4 3.555.132 3.137.043 1.129.087 3.011.13 4.14l3.019 2.008z"
      fillRule="evenodd"
      fill="#9c4314"
    />
    <path
      d="M266.44 320.603c-.125.002-6.887 1.017-5.887.74-.028-1.968-2.685-3.505-3.517-.212-1.167.278-2.213.293-3.38.572-2.378.427-1.59 2.91.164 2.753 1.252-.236 2.131-.205 3.383-.441.757 3.313 3.574 1.349 3.134-.176l5.78-.307c.655-1.015-.331-1.913.324-2.929z"
      fillRule="evenodd"
      fill="#9c4314"
    />
    <path
      d="M264.134 283.553c16.55 9.769 20.803 8.351 20.112 4.023.793 0 .964.69 3.314-1.04-.328 6.4 6.641 10.078 10.89 9.307 3.833.247 3.339 5.317 3.339 5.317.233 5.188-1.512 7.285-1.28 12.473-.057 0-.116-.619-.174-.619-4.716-1.121-14.008-1.253-17.488-2.004 15.951-10.883-12.268-11.18-14.792-11.551-1.906-.248-.546-2.102.567-2.597 8.78-1.731-8.253-10.046-7.81-11.035-1.04-.619.073-1.113.073-1.113 1.166-.758 2.084-.403 3.25-1.16z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.03875}
      fill="#33b1e9"
    />
    <path
      d="M305.46 291.831a5.182 5.182 0 0 0-5.194 5.194c-.866 3.957-.743 9.522 0 14.839a5.182 5.182 0 0 0 5.193 5.194c11.46 1.236 23.784.865 34.378 0a5.182 5.182 0 0 0 5.193-5.194c1.36-4.699.99-9.645 0-14.839a5.182 5.182 0 0 0-5.193-5.194c-11.46-.494-23.166-1.113-34.378 0z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.4840625}
      fill="#983d25"
    />
    <path
      strokeLinejoin="round"
      d="M266.76 150.569l-7.844 6.793c-3.222 1.424-6.724 3.198-4.202 10.785-1.471 9.735 6.373 11.275 13.236 9.244 1.144-2.52 1.507-4.261 2.651-6.782-3.035-.467-4.658.596-7.413.41-1.891-.304-2.031-1.728-1.33-2.662 2.964-1.47 5.648-2.871 8.613-4.342-.07-.443-.14-.116-.21-.56-2.451 1.26-4.202 1.68-6.793 2.731-2.055.724-2.638-1.914-1.821-3.082 0 0 5.322-7.633 5.322-7.703.446-1.605.137-4.308-.21-4.832z"
      fillRule="evenodd"
      stroke="#000003"
      strokeLinecap="round"
      strokeWidth={0.99}
      fill="#268728"
    />
    <path
      d="M288.682 284.03a4.11 4.11 0 1 1-8.22 0 4.11 4.11 0 0 1 8.22 0z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.9894999999999999}
      fill="#fff"
    />
    <path
      d="M269.192 299.53a3.875 3.875 0 1 1-7.75 0 3.875 3.875 0 0 1 7.75 0z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.98930018}
      fill="#fff"
    />
    <path
      d="M365.475 308.21a3.875 3.875 0 1 1-7.75 0 3.875 3.875 0 0 1 7.75 0z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.9795975}
      fill="#fff"
    />
    <path
      strokeLinejoin="round"
      d="M267.125 155.753c.093 2.33.156 5.256.156 6.147-.099-2.179-.862-3.924-1.145-4.781.34-.56.89-1.366.989-1.366z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.5278124999999999}
      fill="#ba4600"
    />
    <path
      d="M305.119 312.908a3.875 3.875 0 1 1-7.75 0 3.875 3.875 0 0 1 7.75 0zM345.984 312.908a3.875 3.875 0 1 1-7.749 0 3.875 3.875 0 0 1 7.75 0zM345.984 294.12a3.875 3.875 0 1 1-7.749 0 3.875 3.875 0 0 1 7.75 0zM305.353 294.12a3.875 3.875 0 1 1-7.75 0 3.875 3.875 0 0 1 7.75 0z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.42480124}
      fill="#973100"
    />
    <path
      d="M267.144 323.51c-.229-.292-1.969-5.225-11.804-5.44-1.384-.08-2.261.317-5.063.124-1.624.133-.988-1.802-.344-2.498 1.066-.749-3.8-.384-5.473-.186-1.687-.097-2.822-.384-3.774-.577-2.95-.283-4.676-2.354-2.52-3.604.902-.887 4.572.122 5.94-.067 1.355-.412 1.165-2.694-.147-2.878-1.866-.276-10.006-.886-9.341-1.8-1.245-2.073-.884-3.146 2.35-2.745 1.802 1.094 1.75-.307 1.311-1.123-.534-1.55-3.496-1.79-3.575-3.135-.482-3.228 1.636-3.662 2.914-3.117.54-.455-2.42-2.98.932-4.21.833-.261 2.546-.058 3.124 3.003 1.744.54.539-2.008 2.904-3.044 2.028-.85-.135 9.081 2.283 8.992 2.083.848 1.673-5.428 3.417-4.207 3.77-.967 1.946 12.045 3.586 11.26 2.724 2.382 3.009-2.142 3.802-1.65 1.334.036 2.222.083 1.478 3.075-.554 2.328.275 2.868.698 3.802 2.547 5.614 6.37 5.561 7.646 8.145.41 3.82-.281 1.359-.344 1.88z"
      fillRule="evenodd"
      stroke="#286726"
      strokeWidth={1.8309375}
      fill="#008d00"
    />
    <path
      d="M314.244 332.144c-4.703 3.863-9.588 6.365-11.377 10.386 2.143-.288 2.971-.646 4.57-.444 1.732-3.875 7.178-5.944 10.393-9.077l-3.587-.865zM326.816 332.556c4.252 3.928 9.523 6.173 11.376 10.323-2.143-.288-3.037-.581-4.314-.251-1.732-3.875-7.434-6.137-10.649-9.27 1.196-.289 2.391-.513 3.587-.802z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.99}
      fill="#009400"
    />
    <path
      d="M323.61 333.353c5.152 3.092 7.208 5.317 10.382 9.274-1.525.092-3.664.784-4.447 1.237-3.834-4.987-6.802-6.76-10.016-9.892 1.195-.289 2.886-.33 4.08-.619z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.99}
      fill="#fff"
    />
    <path
      d="M274.963 165.944c-2.064.568-2.955 2.308-3.143 3.931-7.604 5.326-2.077 15.811 4.975 13.633-5.218-7.813 0-12.227 5.803-9.488 1.759 1.29 2.985 3.98 3.15 3.814 1.105-2.394 5.473-4.478 5.473-4.478s3.519.473 4.153-1.803c.401-1.456 3.64-7.482 3.64-7.482l-11.275-2.321-7.793-.166-4.146 1.824c-.552.884-.284 1.651-.837 2.535z"
      strokeOpacity={0.772}
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.99}
      fill="#ffba00"
    />
    <path
      d="M319.4 333.606c5.153 3.092 7.515 5.987 10.69 9.944-1.397.412-1.87 2.71-2.652 3.164-2.474-4.988-6.564-9.238-10.892-13.484 1.195-.289 1.659.664 2.854.376z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.99}
      fill="#d40000"
    />
    <path
      d="M317.46 333.006c-5.153 3.092-6.952 5.06-10.126 9.018 1.525.092 3.407 1.04 4.19 1.493 3.834-4.987 6.801-6.76 10.016-9.892-1.195-.289-2.886-.33-4.08-.618z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.99}
      fill="#fff"
    />
    <path
      d="M321.66 333.25c-5.153 3.092-7.323 6.178-10.497 10.135 2.554 1.83 1.932 1.941 2.458 2.973 2.474-4.987 7.915-9.109 12.243-13.354-1.195-.289-3.01.536-4.205.247z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.99}
      fill="#d40000"
    />
    <path
      d="M203.69 472.45c0 5.002-7.22 9.058-16.127 9.058s-16.127-4.056-16.127-9.058 7.22-9.058 16.127-9.058 16.127 4.056 16.127 9.058z"
      fillRule="evenodd"
      transform="matrix(.41114 .13432 -.1235 .44716 238.466 46.832)"
      stroke="#000"
      strokeWidth={2.243}
      fill="#973000"
    />
    <path
      d="M313.288 326.763c-3.715 2.669-8.967 6.234-12.681 8.903-.763.651 2.575 1.334 3.798.736 3.92-2.692 5.983-4.455 9.904-7.147l2.242-1.251c-1.6-.115-1.663-1.127-3.263-1.241z"
      fillRule="evenodd"
      stroke="#005e00"
      strokeWidth={0.99}
      fill="#008d2b"
    />
    <path
      d="M203.69 472.45c0 5.002-7.22 9.058-16.127 9.058s-16.127-4.056-16.127-9.058 7.22-9.058 16.127-9.058 16.127 4.056 16.127 9.058z"
      fillRule="evenodd"
      transform="matrix(.3491 -.13705 .16417 .36723 137.816 164.088)"
      stroke="#000"
      strokeWidth={2.549}
      fill="#973000"
    />
    <path
      d="M351.172 285.635c.194-10.192 9.13-1.269 12.638-5.468 8.245-9.717 8.952-10.457 16.236-9.403 19.522 7.672-.855 25.412-20.808 17.334-2.19-1.205-5.876-1.26-8.066-2.464z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.0396874999999999}
      fill="#008d00"
    />
    <g fillRule="evenodd" fill="#6d390b">
      <path d="M424.792 252.051c-.26 1.14-1.592 1.744-2.975 1.351s-2.291-1.634-2.03-2.773 1.592-1.744 2.974-1.351 2.291 1.634 2.03 2.773z" />
      <path
        strokeWidth="1pt"
        d="M424.134 251.534l4.75 4.12-1.251 1.442-4.75-4.12z"
      />
    </g>
    <path
      d="M395.319 266.622l1.037 1.453 3.583-3.122-1.037-1.453-3.583 3.122z"
      fillRule="evenodd"
      strokeWidth="1pt"
      fill="#6d390b"
    />
    <path
      d="M305.46 291.7c6.059 1.855 10.51 23.867 16.446 25.845M311.272 291.578c6.06 1.855 10.387 23.867 16.323 25.845M316.962 291.335c6.06 1.855 10.512 23.99 16.447 25.967"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={1.4840625}
      fill="none"
    />
    <path
      d="M203.69 472.45c0 5.002-7.22 9.058-16.127 9.058s-16.127-4.056-16.127-9.058 7.22-9.058 16.127-9.058 16.127 4.056 16.127 9.058z"
      fillRule="evenodd"
      transform="matrix(.3491 -.13705 .16417 .36723 226.353 148.76)"
      stroke="#000"
      strokeWidth={2.243}
      fill="#973000"
    />
    <path
      d="M398.169 271.675c.303 1.175-.223 2.7-2.29 3.234-2.068.534-4.01-.272-4.313-1.447-.304-1.176.894-2.865 2.962-3.4 2.067-.534 3.337.438 3.64 1.613z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.9450000000000001}
      fill="#dc0000"
    />
    <path
      d="M307.175 328.01c-3.066.621-10.054 2.136-13.1 8.243-.553 1.15-5.15 2.04-4.528.057.719-1.039.975-1.129 1.694-2.167-.056-1.302-3.035-.917-2.83.247-.229-.052-1.67.227-2.346.925-1.827 2.333-4.946 2.229-4.838-.26 1.153-.852 1.737-1.671 2.315-2.926.382-1.363-2.283-1.85-3.145-.845-1.824.955-2.969 2.322-5.14 3.38-2.417.87-4.74-.68-2.635-1.926 1.893-.93.316-3.08-.608-3.149-1.594-.385-8.123.717-9.299.059-.92-.121-2.6-2.54-.63-2.971 1.783-.582 4.761.653 5.53-2.834.771-5.871 10.088 3.004 8.575.553-3.413-5.047 2.397-6.233 4.15-2.796.716 1.552 4.263 3.853 5.292 3.42 1.934.215-3.588-4.888.796-5.72 1 .212 2.784.288 4.014 1.994.915.88 1.11 4.507 4.532 4.808.748-1.104.03-.542-.638-2.059-.006-1.837 3.032-1.687 4.33 1.422 1.286 2.374 8.074.762 14.285.904 1.99-.325 5.192 1.424-5.777 1.64z"
      fillRule="evenodd"
      stroke="#286026"
      strokeWidth={1.8309375}
      fill="#008d00"
    />
    <path
      d="M391.288 271.45c1.092 1.679 1.07 4.339-1.884 6.261s-6.41 1.683-7.504.004c-1.093-1.679-.108-4.951 2.845-6.873 2.953-1.922 5.45-1.071 6.542.608z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.99}
      fill="#dc0000"
    />
    <path
      d="M393.406 264.494c1.023.653 1.677 2.127.528 3.927-1.148 1.8-3.118 2.534-4.141 1.88-1.023-.652-1.3-2.705-.15-4.505 1.148-1.8 2.74-1.955 3.763-1.302z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.9450000000000001}
      fill="#dc0000"
    />
    <path
      d="M396.519 267.55c.662 1.017.648 2.63-1.142 3.795s-3.886 1.02-4.548.003c-.662-1.018-.066-3.001 1.725-4.166 1.789-1.165 3.302-.649 3.965.369z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.9450000000000001}
      fill="#dc0000"
    />
    <path
      d="M403.175 261.522c.498.765.488 1.979-.859 2.855-1.346.877-2.924.767-3.422.002-.498-.766-.05-2.258 1.297-3.135 1.347-.876 2.485-.488 2.984.278z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.7106250000000001}
      fill="#d90000"
    />
    <path
      d="M318.088 323.331c-2.635.31-4.134.472-4.64 2.378-.281 1.294-.057 2.985.168 4.437 0 1.668 2.105 2.773 4.556 3.249h4.218c1.776 0 5.062-1.739 5.062-3.407.263-.943.253-2.465.253-3.495 0-2.805-1.98-2.978-4.456-3.24l-5.161.078z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.99}
      fill="#fff"
    />
    <path
      d="M411.734 290.19c-.29-9.734-2.856-23.842 9.094-28.68 1.542-.402 2.099.467 1.574 1.749l-10.668 26.931z"
      fillRule="evenodd"
      stroke="#286326"
      strokeWidth={1.633125}
      fill="#008f00"
    />
    <path
      d="M427.175 270.372c2.127-4.001 7.385-5.01 9.24-4.885-3.67 3.75-7.338 12.943-9.399 15.951-2.968 5.112-11.624 8.739-16.817 11.748 5.812-7.914 11.164-14.9 16.977-22.814z"
      fillRule="evenodd"
      stroke="#286326"
      strokeWidth={1.633125}
      fill="#008c00"
    />
    <path
      d="M318.313 323.275s-2.639.47-2.697.47-2.052 1.289-2.052 1.289-.41 2.52-.41 2.58.468 2.872.468 2.872l1.232 1.7 3.224 1.113.235-10.024z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.5278124999999999}
      fill="#009400"
    />
    <path
      d="M410.16 293.172c.349-.35 6.84-30.95 17.663-34.575 1.748 2.273.905 7.215.206 9.838-3.323 11.425-11.398 19.257-17.87 24.737z"
      fillRule="evenodd"
      stroke="#286326"
      strokeWidth={1.633125}
      fill="#008d00"
    />
    <g fillRule="evenodd" fill="#6d390b">
      <path d="M434.054 255.517c-.467 1.07.245 2.348 1.59 2.854s2.814.047 3.281-1.024-.244-2.349-1.59-2.854-2.814-.047-3.28 1.024z" />
      <path
        strokeWidth="1pt"
        d="M434.89 255.491l-6.268.492.15 1.904 6.268-.493z"
      />
    </g>
    <g fillRule="evenodd" fill="#6d390b">
      <path d="M407.649 286.838c-.673 1.081-2.228 1.212-3.473.29s-1.71-2.543-1.038-3.625 2.227-1.211 3.473-.29 1.71 2.543 1.038 3.625z" />
      <path
        strokeWidth="1pt"
        d="M407.175 286.057l3.28 6.032-1.775 1.026-3.28-6.031z"
      />
    </g>
    <g fillRule="evenodd" fill="#6d390b">
      <path d="M415.414 295.28c-.583-1.132.103-2.534 1.532-3.13s3.06-.164 3.644.968-.102 2.534-1.531 3.13-3.061.164-3.645-.968z" />
      <path
        strokeWidth="1pt"
        d="M416.327 295.274l-6.86-.278.03-2.051 6.86.278z"
      />
    </g>
    <path
      d="M405.453 302.285c6.65-3.604 2.483 1.452 2.07 4.22-1.965 6.83-3.802 6.874-6.112 8.038-3.446 3.143-14.487 1.618-19.617 2.913 6.43-4.67 17.229-10.502 23.66-15.171zM395.497 300.7c2.776-2.203 3.232-7.068 3.047-8.754-2.516 3.594-8.957 7.543-11.021 9.621-3.534 3.043-5.704 11.183-7.607 16.12 5.41-5.822 10.172-11.164 15.58-16.987z"
      fillRule="evenodd"
      stroke="#286326"
      strokeWidth={1.3284375}
      fill="#008c00"
    />
    <path
      d="M360.922 328.647c4.349-1.276 11.76 1.937 12.97 3.35-5.247 0-13.75 3.643-17.342 4.273-5.73 1.45-21.62-7.515-27.31-8.795 9.498-.479 21.96 2.549 31.682 1.172z"
      fillRule="evenodd"
      stroke="#286326"
      strokeWidth={1.633125}
      fill="#008c00"
    />
    <path
      d="M327.819 327.728c3.714 2.67 8.966 6.235 12.68 8.904.763.65-2.574 1.334-3.798.736-3.92-2.692-5.983-4.455-9.903-7.147l-2.243-1.252c1.6-.115 1.663-1.126 3.264-1.24z"
      fillRule="evenodd"
      stroke="#004500"
      strokeWidth={0.99}
      fill="#00602b"
    />
    <path
      d="M379.372 317.463c.446-.169 18.153-24.073 29.16-23.085.661 2.623-2.017 6.561-3.661 8.556-7.408 8.584-17.624 12.265-25.5 14.529z"
      fillRule="evenodd"
      stroke="#286326"
      strokeWidth={1.5590625}
      fill="#008c00"
    />
    <g fillRule="evenodd" fill="#6d390b">
      <path d="M377.195 313.952c-1.103.637-2.536.02-3.2-1.38s-.31-3.05.793-3.687 2.535-.019 3.2 1.38.31 3.05-.793 3.687z" />
      <path
        strokeWidth="1pt"
        d="M377.145 313.04l.051 6.866-2.05.068-.051-6.865z"
      />
    </g>
    <g fillRule="evenodd" fill="#6d390b">
      <path d="M381.821 323.761c.074-1.271 1.378-2.129 2.912-1.915s2.718 1.418 2.644 2.689-1.378 2.129-2.912 1.915-2.718-1.417-2.644-2.689z" />
      <path
        strokeWidth="1pt"
        d="M382.61 324.22l-5.764-3.73 1.07-1.75 5.763 3.73z"
      />
    </g>
    <path
      d="M231.613 236.94c.518-.773 1.714-1.282 3.203-.447 1.49.834 2.12 2.296 1.6 3.07-.518.775-2.193 1.008-3.683.174-1.489-.834-1.64-2.022-1.12-2.796z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.73875}
      fill="#dc0000"
    />
    <path
      d="M357.894 325.46c7.312-1.934 6.876-5.455 10.293-8.534-7.909-1.158-14.218 1.641-17.596 3.5-5.337 3.442-6.718 7.178-11.342 9.751 7.883-1.006 11.434-2.138 18.644-4.718z"
      fillRule="evenodd"
      stroke="#286326"
      strokeWidth={1.3284375}
      fill="#008c00"
    />
    <path
      d="M334.044 327.597c20.914 1.578 17.58-6.913 40.5-6.703-.338 2.684-4.714 6.052-6.972 7.312-10.023 5.3-26.493 7.783-33.529-.609z"
      fillRule="evenodd"
      stroke="#286326"
      strokeWidth={1.5590625}
      fill="#008c00"
    />
    <path
      d="M323.413 323.219l.058 9.848 2.697-1.055s1.113-1.759 1.113-1.876c0-.117.47-2.404.47-2.462 0-.059-.235-2.814-.235-2.814l-2.052-1.348-2.051-.293z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.5278124999999999}
      fill="#d40000"
    />
    <path
      fillRule="evenodd"
      strokeWidth="1pt"
      fill="#6d390b"
      d="M236.346 231.77L233 228.091l1.139-.964 3.346 3.677z"
    />
    <path
      d="M232.137 234.035c.568-.988 1.877-1.638 3.507-.572 1.631 1.064 2.32 2.93 1.752 3.919-.567.988-2.4 1.287-4.032.222-1.63-1.065-1.794-2.58-1.227-3.57z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.87375}
      fill="#dc0000"
    />
    <path
      d="M241.353 229.91c.953.039 1.987.882 1.934 2.8-.054 1.916-1.09 3.382-2.044 3.342s-1.965-1.502-1.912-3.42c.054-1.916 1.067-2.76 2.022-2.722z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.7940625}
      fill="#dc0000"
    />
    <path
      d="M236.656 230.678c1.08-.283 2.489.196 2.996 2.098.508 1.901-.22 3.691-1.3 3.975-1.081.283-2.647-.813-3.155-2.715-.507-1.902.378-3.074 1.46-3.358z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.87}
      fill="#dc0000"
    />
    <path
      strokeLinejoin="round"
      d="M263.6 261.175c-3.261-8.29-12.16-22.054-21.224-15.42-10.06 8.677 4.588 22.329 17.08 21.555l4.145-6.135z"
      fillRule="evenodd"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={0.99}
      fill="#008d00"
    />
    <path
      d="M237.716 236.875c1.741-1.171 4.536-1.198 6.611 1.845 2.075 3.044 1.89 6.655.148 7.826-1.743 1.172-5.198.207-7.273-2.836-2.075-3.043-1.229-5.662.514-6.835z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.0359375}
      fill="#dc0000"
    />
    <path
      d="M231.275 223.028c.794-.534 2.068-.546 3.015.842.946 1.387.861 3.035.067 3.57-.794.533-2.37.093-3.317-1.295-.946-1.387-.56-2.582.235-3.117z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.744375}
      fill="#dc0000"
    />
    <path
      d="M291.294 271.038c-4.097-7.29-15.278-16.405-26.667-10.573-13.469 9.452 5.432 23.611 24.775 16.63 1.735-1.798.155-4.26 1.891-6.058z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.0396874999999999}
      fill="#008d00"
    />
    <path
      d="M329.263 275.35c-4.097-7.289-26.056-15.575-35.622-8.583-11.975 13.432 5.599 22.782 29.253 16.132 1.736-1.798 4.633-5.751 6.369-7.55z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.0396874999999999}
      fill="#008d00"
    />
    <path
      strokeLinejoin="round"
      d="M243.978 248.125c.117 0 2.462 2.931 2.462 2.931l-.117-4.104M248.084 253.863l2.463 2.462M256.756 252.222l.235 2.814 1.524-.117M256.756 261.606c-.586-.351-2.58-1.993-2.58-1.993M251.01 261.84l-3.284-1.054"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M244.794 255.625l-3.166-1.055"
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      strokeLinejoin="round"
      d="M238.822 253.75h-2.697"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      strokeLinejoin="round"
      d="M251.478 244.835v-3.518"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={0.5278124999999999}
      fill="none"
    />
    <path
      strokeLinejoin="round"
      d="M246.79 263.838c-.35 0-4.924-.235-4.924-.235M255.003 266.997l-3.517 1.172M260.272 254.453c.117-.117 2.931-1.524 2.931-1.524M252.303 250.469c0-.117-.938-3.869-.938-3.869"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M318.031 323.266c-2.634.309-4.133.471-4.64 2.377-.28 1.294-.056 2.985.169 4.438.469 2.43 2.105 2.773 4.556 3.248h4.218c1.776 0 4.652-1.152 5.12-3.348.322-1.119.195-2.523.195-3.554-.234-2.57-1.98-2.978-4.456-3.24l-5.162.079zM318.322 323.275l-.083 9.783M323.46 323.275l-.084 9.783"
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M429.256 239.613c1.547-5.086-3.807-6.288-5-9.144-2.444 4.784-1.587 9.656-1.155 12.218 1.003 4.16 4.69 7.036 5.302 10.55 1.08-5.246.907-8.462.853-13.625z"
      fillRule="evenodd"
      stroke="#286326"
      strokeWidth={0.8887499999999999}
      fill="#008c00"
    />
    <path
      d="M436.344 234.888c.104-2.783 3.734-4.776 5.197-5.215-.907 5.411.722 7.953.291 10.172-.323 3.624-6.96 9.16-9.782 12.236 1.43-5.944 2.862-11.25 4.293-17.193z"
      fillRule="evenodd"
      stroke="#286326"
      strokeWidth={1.18125}
      fill="#008c00"
    />
    <path
      d="M428.694 256.581c.177-.332-2.762-25.866 4.6-31.164 1.93 1.133 2.562 4.788 2.704 6.792.408 8.801.696 13.273-7.304 24.373z"
      fillRule="evenodd"
      stroke="#286326"
      strokeWidth={1.2646875}
      fill="#008c00"
    />
    <path
      d="M281.01 255.972c2.106.669 3.962 2.966 2.823 6.7-1.14 3.735-2.904 6.137-5.672 5.303-3.6-.834-4.245-4.17-3.106-7.905 1.139-3.734 3.847-4.766 5.954-4.098z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.0940625}
      fill="#dc0000"
    />
    <path
      d="M284.572 252.156c.67.47 1.07 1.456.253 2.572-.816 1.115-2.155 1.5-2.824 1.03-.67-.47-.802-1.813.014-2.93.816-1.114 1.887-1.142 2.557-.672zM279.031 251.013c.8-.17 1.794.209 2.054 1.567.26 1.357-.37 2.6-1.17 2.77-.8.169-1.873-.65-2.134-2.008-.26-1.357.45-2.16 1.25-2.33z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.2534375}
      fill="#dc0000"
    />
    <path
      d="M281.366 253.975c.783.235 1.473 1.045 1.05 2.361-.424 1.316-1.574 2.103-2.357 1.868-.783-.236-1.332-1.47-.908-2.785.423-1.315 1.43-1.68 2.215-1.444z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.2534375}
      fill="#dc0000"
    />
    <path
      d="M282.5 249.269c.653.178 1.23.79.876 1.786s-1.313 1.592-1.966 1.414c-.654-.179-1.111-1.112-.758-2.108.353-.995 1.194-1.27 1.848-1.092z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.9965624999999999}
      fill="#dc0000"
    />
    <path
      d="M285.931 255.26c.715.491 1.116 1.427.177 2.365-.938.938-2.42 1.162-3.135.67-.716-.492-.808-1.728.13-2.667.937-.937 2.113-.86 2.828-.368z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.2553125}
      fill="#dc0000"
    />
    <path
      d="M276.931 253.206c.728-.087 1.584.345 1.703 1.611.12 1.267-.545 2.351-1.273 2.439-.729.087-1.618-.755-1.738-2.02-.12-1.267.58-1.942 1.308-2.03z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.1390625}
      fill="#dc0000"
    />
    <path
      d="M266.019 319.056v-.117.117h0z"
      stroke="#000"
      strokeWidth={0.5278124999999999}
      fill="none"
    />
    <path
      d="M360.584 270.025c4.104 2.189 2.697 7.309-.234 8.677-.157-3.362-2.306-4.378-5.51-5.159 1.68-.938 3.478-3.987 5.744-3.518z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.99}
      fill="#fff"
    />
    <path
      d="M321.397 290.5c1.51-22.251 18.416-24.95 29.622-21.098 16.41 11.907-.232 21.8-24.794 22.44-2.19-1.204-2.638-.137-4.828-1.342z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.0396874999999999}
      fill="#008d00"
    />
    <path
      d="M326.31 265.497c-5.249-.212-6.833 4.91-4.774 7.582 2.09-2.811 4.763-2.589 8.327-1.625-1.092-1.664-1.081-5.204-3.554-5.957z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.0518750000000001}
      fill="#fff"
    />
    <path
      d="M329.047 272.153c-4.104 2.19-3.23 7.309-.299 8.677.157-3.361 2.306-4.378 5.51-5.159-1.68-.938-2.944-3.987-5.211-3.518z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.99}
      fill="#fff"
    />
    <path
      strokeLinejoin="round"
      d="M361.128 270.447c.048-1.83-1.397-3.414-3.091-3.67-2.042-.248-4 1.161-6.043-.33-.248-.167-4.99-4.26-6.351-6.166-1.361-.747-4.213-2.145-4.213-2.145-1.68 2.189-2.863 4.709-5.29 6.151-1.207.484-1.668 1.05-3.87.87-2.276-1.064-4.78-1.61-6.082-.455 1.107 2.193.805 4.967.337 7.077.821.47 1.725-.092 2.711.128 3.04.08 2.267 3.347 3.4 4.754 3.203.871 4.83-.663 5.297-3.274.847-1.333 3.435-1.505 5.276-2.008 1.993-.385 4.484-1.019 6.311.006 1.51.802 2.52 1.77 3.283 3.4 0 0 2.403.215 4.807-.234.083-1.444-.213-4.07 3.518-4.104z"
      fillRule="evenodd"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={0.99}
      fill="#f6aa00"
    />
    <path
      d="M339.884 260.435l.118 5.276c.625 1.915 4.885 1.72 5.393.469l-.117-5.98"
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M341.29 271.685c.92-.312 1.261-2.87 1.261-2.87M345.05 270.981l.234-2.11M348.913 270.981l-.347-2.221M338.713 269.34c-.143.08-1.993-2.227-1.407-1.992M335.319 272.744c.234 0-3.063-3.415-2.477-3.18M332.262 266.416c-.085-.262-.234-1.524.352-1.29M339.613 265.628c-5.01 4.324-9.726 2.505-10.407 6.14M352.016 268.075c.175-.212.778-1.33.147-1.329"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      strokeLinejoin="round"
      d="M271.569 270.213c.065-.097 3.806-.406 3.806-.406l-3.47-2.194M294.369 273.944c.065-.097 3.806-.406 3.806-.406l-2.972-3.44M303.584 274.572c-.183-.595 3.932.092 3.807-.406l-2.598-2.817M298.663 261.447c.117 0 2.462 2.931 2.462 2.931l-.118-4.104M369.275 281.013c.09.076-.022 4.18-.022 4.18l2.693-2.92M339.219 279.963c.08.085-.453 3.801-.453 3.801l4.015-2.13M268.84 260.913l2.463 2.462M264.36 265.019l2.462 2.462M281.15 271.403l3.468-.31M275.637 274.825l3.474-.246M300.753 266.94l2.462 2.463M311 268.216l2.462 2.462M291.903 263.735l2.462 2.462M266.019 255.916l2.462 2.462M293.534 285.888l2.278-2.634M305.075 288.072l2.278-2.634M260.778 274.6l3.468-.31"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      strokeLinejoin="round"
      d="M267.34 272.135c-.566.03 1.757-.15 2.398.106l-3.425-2.45"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={1.0537500000000002}
      fill="none"
    />
    <path
      strokeLinejoin="round"
      d="M271.672 279.475l3.468-.31M312.8 276.11l3.473-.247M306.912 280.975l3.474-.246M311.094 263.116c.117 0 2.462 2.93 2.462 2.93l-.118-4.103M344.89 273.606l-2.462 2.463M352.963 276.297l-2.463 2.462M349.372 283.216l-2.462 2.462M378.331 283.853l-2.462 2.463M363.088 282.063l-2.463 2.462M378.078 267.325l-2.462 2.462M389.731 283.966l-3.467-.33M360.613 291.69l.168-3.478M371.6 275.95l1.772-2.998M377.113 279.278l1.771-2.998M381.706 288.813c-.076.089-3.828-.03-3.828-.03l2.69 1.961M329.61 287.772c.08.086-.453 3.801-.453 3.801l4.015-2.13M298.719 280.975c.457-.339 2.777-1.061 2.653-1.56l-2.47-.894"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      strokeLinejoin="round"
      d={`M403.278 257.528c1.627 1.263 4.37-13.105 3.95-17.601 0-.297-.51-9.832 1.486-16.643 1.26-2.293 1.306-19.474-.585-23.991 1.506-.127 3.332-.615 3.557-2.456-6.958 2.576-8.61-14.707-15.306-24.632-6.537-9.954-14.651-15.756-23.08-21.796.657-1.69 1.63-3.275 2.918-4.86-10.35 5.185-26.478-13.586-50.276-12.183-5.364.534-7.891.858-9.263 4.124-4.424.375-8.954 1.38-8.966 7.22.009 1.398 1.279 3.952 4.124 3.985 3.9 1.123 7.063.25 9.702 5.68.198 1.486.501 4.127.7 5.613 0 0-3.491-4.422-5.4-5.157.506-.735-.3-1.24 1.17-2.377-1.786-1.033-4.983-.193-4.983-.193s-6.912-3.253-12.48-2.377c0-.594-1.066-4.508-1.066-4.508-.985 2.757-3.16 2.608-3.479 5.226-.594-1.882-1.399-4.185-1.993-6.067-1.954 2.669-1.387 5.547-2.08 8.32-.775.631-2.32.666-2.709-1.12-.198-2.18-.466-2.397-.454-4.996-1.41 2.458-3.102 3.655-3.672 7.9-.594-1.585-.908-3.1-1.503-4.685.076 5.52-4.686 8.833-9.195 12.708-1.267 2.345.198 2.378.297 3.566l2.378 1.189c1.386-.099 2.878-.198 4.265-.297.693.891.126.945 1.975 1.52 4.953 1.388 11.152-4.567 16.015 4.79-2.24 1.863-4.48 6.249-3.777 7.062.892 0-1.79 1.261 1.834.105-3.782 3.678-6.345 8.513-6.345 8.81-.42 1.033 1.524-.14 1.118 1.737.531-1.407.899-.117.899-.117-8.632 9.337-.289 19.35-1.219 24.744 1.435 2.311 1.614-.044 3.409-.3 1.518 6.616 5.861 10.629 8.536 15.88-1.381-.424-4.125-.574-5.611.055.126 2.49 2.377 4.857 4.16 7.034-1.287.395-2.476.791-3.764 1.19-2.674 1.386-4.452 2.843-6.334 4.92-1.255 3.033 5.99 3.769 9.464 4.28-.315 1.088-.759 2.457-.128 3.653 5.463.526 11.775-1.089 11.775-1.386 0-.3 1.37-1.068 1.37-1.068.735 1.472 2.353 1.907 3.07 1.698 1.032 0 2.635-4.113 1.9-7.263 1.98 2.374 3.845 6.158 5.826 8.537.6.63 1.375.166 1.87-.257 1.684 2.676 4.009 5.351 5.693 8.023.891 1.021.7.645 1.906.72 1.101-.356 2.04-.502 2.616-2.64 0 0 .365.332.885 1.51 1.33.946 2.269-1.328 3.004-2.064.42-1.014 2.06.198 2.06-.396.595.396.985 2.138 1.58 2.533.909-.336 1.812-2.335 1.881-4.456.904 1.86 1.183 1.706 1.876 2.204.595-.498.781-2.438 1.376-2.933-.129-1.025 7.137 7.006 7.434 7.006.718.523 4.824 1.781 5.664.313 2.05 1.37 7.568 2.216 8.462.016 4.542 1.939 9.886-.234 9.66-2.403 4.142 1.655 10.599.55 10.599.253.735-.087 2.732-2.026.84-3.494-13.769-9.61-34.261-25.522-42.147-29.353 0-2.836-2.146-13.07-4.457-15.887-.42-1.453.526-3.25 1.892-3.144 5.358 5.01 7.305 4.532 10.142 5.34 3.07 2.422 4.172 6.12 7.243 9.488 1.447.463 3.157 1.928 2.713.5-1.916-4.81-4.233-9.466-9.97-15.719 2.971 1.486 7.839 5.422 11.126 8.274 2.191 3.61 2.806 6.487 4.788 11.043 1.435.91 2.902 4.268 2.692 1.485-.315-5.234-3.986-13.546-3.986-14.14 5.836 4.655 5.775 11.87 7.534 16.285 1.524 2.24 2.29 5.217 2.921 4.52.736-1.017-1.732-13.62-1.732-13.62-.396-1.584-.595-3.38-.99-4.964 4.343 2.5 5.861 12.04 7.894 23.469.005 1.82.747 3.815.648 5.003.932 1.152 2.006 4.33 1.957 2.434 0 0 .003-18.593-1.257-22.865-.316-2.275.558-5.997.558-5.997 1.585 7.726 3.275 16.082 4.86 23.808v5.648c.792.791 1.584 1.583 2.377 2.379l1.486-13.968s-1.783-16.346-1.783-16.642v-4.755c-.036-1.675 1.503-1.354 2.518.544.198 4.061.186 7.282.384 11.344.694 4.653 1.177 8.049 1.555 13.966.186 4.849.373 16.316 1.4 16.118z`}
      strokeOpacity={0.772}
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.99}
      fill="#9c4314"
    />
    <path
      strokeLinejoin="round"
      d="M326.3 284.406c-.223-.523-.384-2.948-.898-2.943l-1.446 2.193M369.753 271.169l-.296 2.453M348.144 289.263c-.565.069-2.94-.45-3.077.044l1.705 1.999"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M311.806 234.297v.257-.257.257-.257 4.485c.131.636.128 1.344.128 2.05.08.544.27 1.196.513 1.795.035.76.247 1.258.513 1.922.054.655.278 1.216.512 1.794.056.658.269 1.003.385 1.538.185.616.41 1.016.64 1.41.167.167.231.333.385.384"
      stroke="#000"
      strokeWidth={0.5278124999999999}
      fill="none"
    />
    <path
      d="M301.803 250.056c0-.207-.032-.837.257-1.281.453-.645.817-1.045 1.409-1.666.7-.445 1.2-.973 1.794-1.538.638-.407.959-.767 1.538-1.153.355-.363.766-.542 1.153-.77.441-.216.762-.536 1.41-.64.39-.195 1.201-.128 1.794-.128.611 0 .825-.117 1.41-.128"
      stroke="#000"
      strokeWidth={0.5278124999999999}
      fill="none"
    />
    <path
      d="M394.963 205.544c1.98 1.436 4.16 4.557 5.052 10.203M383.825 207.466c2.872 2.575 4.494 5.376 6.637 11.689"
      strokeOpacity={0.772}
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M376.887 210.54c1.75 1.998 2.807 4.095 3.765 6.588M365 204.006c2.278 2.625 5.943 6.637 7.825 10.698"
      strokeOpacity={0.772}
      fillRule="evenodd"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={0.99}
      fill="#00c600"
    />
    <path
      d="M316.616 136.975c.166 11.418 16.878 8.633 18.286 19.361 3.198 11.708 1.865 19.272-2.814 22.989-2.656 2.735-.625 6.987.166 9.17 4.344 11.01 10.903 12.782 13.723 22.285"
      strokeOpacity={0.772}
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M310.363 144.766c0-.22.392-.602.78-.78 1.663-.542 2.686-.574 4.387-.682 1.463 0 2.828.064 4.29.292"
      strokeOpacity={0.772}
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M332.01 249.578l5.81 9.452M350.525 235.516l31.11 23.824M349.69 242.05l22.734 19.957M306.922 217.29c2.994 5.945 11.454 13.84 16.53 15.1.174-3.819-.042-5.293-.65-7.94"
      strokeOpacity={0.772}
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M316.55 213.906c2.994 5.945 5.727 12.279 13.668 15.88.824-5.77-.954-13.623-5.337-21.607"
      strokeOpacity={0.772}
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M317.956 205.938c2.734 1.649 5.207 2.386 7.03 2.603.824-5.77 1.546-11.877-3.162-20.14"
      strokeOpacity={0.772}
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M307.438 209.35c4.035 4.383 7.289 4.599 9.111 4.816 1.345-3.948 1.91-12.322.26-21.348M296.984 212.866c4.018 5.2 13.28 15.068 18.264 18.655.173-.827.43-1.212.364-3.858M365.6 155.763c4.304 4.961 20.912 21.659 24.2 29.474 5.675 12.773 16.14 15.202 18.749 13.772M337.147 224.79c1.494 6.112 4.208 17.23 8.119 18.988.673-.657 1.242-1.872 1.176-4.52"
      strokeOpacity={0.772}
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M314.572 190.15c1.756 1.788 2.154 3.417 3.976 3.634 2.22-1.816 6.13-11.938 4.726-19.41"
      strokeOpacity={0.772}
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M305.366 189.869c.825 4.021 1.595 7.418 4.441 7.449 4.733-3.956 6.13-12.812 4.726-20.283M303.528 211.15l-2.13-4.683M349.512 249.044l14.266 12.959M342.716 243.831l4.402 12.393M323.319 232.488c2.994 5.945 9.372 14.525 14.448 15.784.174-.823.077-1.54.011-4.183M315.594 231.297c2.994 5.941 11.79 15.626 16.867 18.464.174-.823.914-.981.848-3.625M337.503 248.022l6.356 10.54M329.9 221.566c2.733 1.649 5.603 3.03 7.425 3.248.279-6.426-1.961-16.79-6.56-24.725"
      strokeOpacity={0.772}
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M298.269 187.872c-.812 3.04-.7 6.361 2.147 6.392 7.898-3.41 3.182-6.807 9.965-18.318M308.694 166.966c2.994 5.944 3.871 9.985 8.536 11.512.934-.42 3.256-10.927-4.62-19.457"
      strokeOpacity={0.772}
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M318.284 171.916c1.538 1.788 3.792 2.215 5.615 2.105 1.783-3.562-2.03-13.654-7.05-18.873M362.403 163.685c3.758 5.289 20.247 23.752 27.314 29.645 1.588-.202 3.938 1.77 1.74-4.903"
      strokeOpacity={0.772}
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M360.547 175.366c3.758 5.289 10.64 14.243 17.706 20.137 1.777.663 3.496.45 4.06-.012.606-.583.055-4.775.211-9.04"
      strokeOpacity={0.772}
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M356.075 182.031c4.304 4.744 9.985 10.204 16.942 16.535 1.777.663 3.312.69 3.515-.012.169-.693.491-.518.101-4.782"
      strokeOpacity={0.772}
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M350.066 190.544c4.304 4.743 8.238 8.239 12.14 9.11 1.885.227 2.874.253 3.077-.448.169-.693.054-4.011-.007-7.84"
      strokeOpacity={0.772}
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M343.953 196.872c4.304 4.743 4.308 6.71 8.21 7.582 1.885.226 3.281-.022 3.623-.667.606-1.348.818-2.81.756-6.638"
      strokeOpacity={0.772}
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M342.21 165.869c4.335.789 4.694-2.96 4.342-5.64-.427-3.362-2.804-4.833-5.62-4.127M339.8 180.719c2.043.789 4.61.738 5.544-1.601.754-1.78.471-6.143-2.344-5.437"
      strokeOpacity={0.772}
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M342.866 173.622c3.898.243 4.263-1.537 4.124-3.785-.154-2.62-1.93-4.614-4.746-3.907"
      strokeOpacity={0.772}
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M346.653 163.44c5.693-3.426 22.093 10.316 9.62 14.691M345.444 173.172c5.693-3.427 18.23 7.784 5.518 12.151M343.316 180.906c6.356.221 13.67 10.424 1.208 11.67"
      strokeOpacity={0.772}
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M335.825 186.353c2.043.79 3.223 1.3 5.046-.274.72-.66 1.669-3.688-1.017-5.367"
      strokeOpacity={0.772}
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M282.603 174.025c2.15-2.774 7.404-4.543 9.202-.87M339.66 186.85c3.702 1.216 9.594 11.517-.3 12.568"
      strokeOpacity={0.772}
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M334.934 140.256c4.27.808 6.427 7.708 9.83 8.24 6.224.928-.804-7.204-2.151-8.118"
      strokeOpacity={0.772}
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M271.972 169.75c1.915.078 3.713-.274 4.924-2.54M290.956 189.522c1.064 1.984 3.799 1.191 6.059-.185 3.091-1.768.486-7.98 7.855-13.276M294.875 215.678c4.017 5.2 11.638 12.957 16.387 17.127.174-.823.944-1.242.878-3.89M311.113 232.46l9.136 12.693M330.163 229.394c1.494 6.11 7.437 15.786 11.347 17.544.673-.66 1.125-3.28 1.06-5.929M328.034 246.897l-.558 5.664M341.713 218.575c1.494 6.111 3.739 20.982 7.18 23.678.674-.657 2.064-13.012 1.998-15.658M337.1 218.153c2.03.243 3.213.236 4.801.218.28-6.425-2.505-13.979-7.104-21.914"
      strokeOpacity={0.772}
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M348.416 202.281l-.317 6.498"
      strokeOpacity={0.772}
      fillRule="evenodd"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={0.99}
      fill="#00c600"
    />
    <path
      d="M325.475 199.506c2.147.829 3.682 1.097 5.388.962 1.762-8.702-2.675-8.711-8.204-14.863"
      strokeOpacity={0.772}
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M350.178 141.663c4.27.807 1.563 7.194 7.368 9.177 4.873 1.624 2.127-5.093.78-6.007"
      strokeOpacity={0.772}
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M343.831 156.006c3.081-2.24 14.096.862 17.823 3.992 1.068.996 2.697 4.97-2.366 8.623M285.472 161.266c8.842-8.629 12.943-7.646 23.066-1.282 1.453.342 3.033.043 3.973-.512.512-1.24.024-2.501-.641-3.46-4.528-3.246-7.902-4.186-12.174-3.588M298.203 193.29c-1.988 2.931-3.614 9.305-.256 16.403.133.817.991 1.634.128 2.179-1.655.833-2.403 2.21-3.332 3.588M349.728 238.61c.06-10.753-1.51-19.33-5.8-27.093M331.156 196.74c1.42-.15 3.202.243 4.078-.18.423-1.57-.785-3.504-1.269-4.984.816-.09 1.813-.09 2.447-.272.362-1.36 0-3.262 0-4.893"
      strokeOpacity={0.772}
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M278.047 166.14c.341-2.391 2.477-5.04 4.87-6.406 1.153-.641 1.922.128 2.434.383.641 1.026.256 2.948 0 3.717-.64 1.282-1.922 2.307-4.228 3.204-1.197-.513-1.88-.385-3.076-.897z"
      strokeOpacity={0.772}
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.99}
      fill="#fff"
    />
    <path
      d="M298.55 211.76c.513.256 5.638 5.894 5.638 5.894h3.076l.256-8.586"
      strokeOpacity={0.772}
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      strokeLinejoin="round"
      d="M306.875 195.231c-1.025 3.375-.64 6.75 0 10.124"
      strokeOpacity={0.772}
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M300.2 211.15l1.2-4.683M302.394 193.431c-1.538 2.82-1.976 7.451-1.176 10.814M344.281 212.172l-2.9.058"
      strokeOpacity={0.772}
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M240.397 201.278c.407 1.256-.963.582-1.257.935-1.44.508-3.722-1.256-5.164-5.522.704-1.194 4.839-3.761 6.166-3.209 0 0 2.602.992 2.914 2.079-.5 1.585-2.747 5.894-2.659 5.717z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.99}
      fill="#9f3000"
    />
    <path
      d="M344.281 212.172l.048-5.709M348.997 242.163l.814 13.928"
      strokeOpacity={0.772}
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M240.303 201.766c2.81 2.642 7.225.87 7.927 7.325.301 3.613-4.816 10.838 0 17.36 1.706 2.51 6.122 5.218 6.122 5.218 2.308 2.576 3.01 7.158 4.515 10.737 3.178 4.75 7.56 5.787 11.038 4.617 0 0 11.44-5.118 11.44-5.219 0-.1-5.82-7.827-5.82-7.726 0 .1-6.523 5.52-6.623 5.52-.703-.101-4.516.3-5.92-4.517-.1-6.154-3.144-9.562-8.028-12.04-2.475-1.875-4.449-4.85-2.308-9.032 1.237-3.813 2.475-10.236-1.907-14.55-2.81-1.873-4.817-3.345-7.827-3.914-3.98 1.506-3.947 1.104-2.609 6.222z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.99}
      fill="#238700"
    />
    <path
      d="M296.872 148.047c-1.538 2.819-1.398 4.51-1.142 7.328M289.063 161.913h3.587c.955-.026 1.363-.388 2.051-.897.462-.261.953-.655 1.41-1.025.38-.272.836-.591 1.281-.77.727 0 1.295.054 1.922.257.58.243 1.057.591 1.538.897.48.192.913.256 1.666.256.782 0 1.602-.036 2.306.129.678.045 1.436.194 1.923.384.62.391.994.858 1.41 1.282.024.68.247 1.096.256 1.793 0 .596.067 1.404-.128 1.795 0 .737-.118 1.261-.257 1.794-.47.442-.641.784-1.281.897-.504.395-1.258.384-2.05.384h-2.051c-.445-.37-.985-.757-1.538-1.281-.297-.69-.494-.914-1.153-1.154a12.75 12.75 0 0 0-1.922-.128c-.626 0-1.148.044-1.538-.256-.354-.337-.864-.514-1.41-.64-.58-.165-1.265-.129-1.922-.129h-1.025"
      strokeOpacity={0.772}
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M292.39 163.066l.129.128c-.291-.29-.185-.15.512.128.849.196 1.761.358 2.692.385.881 0 1.683.108 2.562.128.613 0 1.259.05 1.795-.128"
      strokeOpacity={0.772}
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M300.594 161.013h-.128c.401 0 .154-.034-.385.64-.052.732-.209 1.136.128 1.795.418.139 1.125.449 1.41.768.412.295.384.56.384 1.282-.246.4-.468.723-.768 1.281-.162.403-.371.944-.513 1.41-.146.585-.249 1.142-.256 1.794v1.281M346.99 146.088c.144.273 2.6 5.179 5.652 2.067.453-.53.61-.915.61-1.82 0-.471-.064-1.02-.18-1.409"
      strokeOpacity={0.772}
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M273.031 244.75c1.478 2.06 4.164 1 4.703-.65-1.84.12-2.542-.966-3.191-2.63-.393.953-1.926 2.098-1.512 3.28z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.5371874999999999}
      fill="#fff"
    />
    <path
      d="M359.956 150.672c0 .095 2.603 2.489 6.54 2.489.95 0 5.466-1.14 6.904-3.146"
      strokeOpacity={0.772}
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M365.403 152.978c.058.385.181 1.787.181 2.719-.012.987.225 1.813-.147 2.636-.405 1.05-.855 1.469-1.846 1.83-.807.364-.979.015-1.878.048M343.738 148.019c0 .06 2.776 6.657 3.69 7.326"
      strokeOpacity={0.772}
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M274.84 243.55c1.479 2.06 4.165 1 4.704-.65-1.84.12-2.543-.966-3.192-2.63-.393.953-1.925 2.098-1.511 3.28z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.5371874999999999}
      fill="#fff"
    />
    <path
      d="M277.644 242.35c1.478 2.06 4.164 1 4.703-.65-1.84.12-2.543-.966-3.192-2.63-.393.953-1.925 2.098-1.511 3.28z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.5371874999999999}
      fill="#fff"
    />
    <path
      d="M327.894 144.644H328.8c2.88-.486 12.554 1.299 14.235 3.08M329.703 191.397c-.06-.06.135 1.11.075 1.049.357.357-.054-.966-.256-1.774-.302-.72-.363-1.196-.363-2.175v-.725M311.619 234.053v.258-.258.258-1.05 5.277c.13.637.128 1.345.128 2.05.08.546.27 1.195.513 1.797.035.76.247 1.259.512 1.92.055.657.278 1.219.513 1.796.055.657.268 1.002.384 1.536.186.618.41 1.017.64 1.41.168.17.33 1.028.484 1.076"
      strokeOpacity={0.772}
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M303.8 226.497v3.461c.167.849.196 1.747.384 2.563.07.732.247 1.357.385 2.05.061.685.881 3.115 1.153 3.717.304.566.752 1.155 1.026 1.535.512.159.93.34 1.537.384h1.794c.72-.138.967-.214 1.282-.768.173-.344.162-.585.384-.768M301.625 249.822c0-.21-.032-.839.256-1.282.454-.646.818-1.045 1.41-1.667.7-.447 2.441-2.842 7.689-4.227.611 0 .825-.119 1.41-.13M302.244 238.197c.042.044 2.868 1.52 4.333 1.583"
      strokeOpacity={0.772}
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M310.316 243.156h-.14.14c-.047 0-.094 0 0 0z"
      stroke="#000"
      strokeWidth={0.5278124999999999}
      fill="none"
    />
    <path
      d="M309.05 243.016c-.42-.28-14.006-4.202-13.727-4.202.28 0-4.972 3.572-4.972 3.572l12.956 4.412 5.182-3.782h.56z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.99}
      fill="#ffbc00"
    />
    <path
      d="M296.075 238.703c.858-2.179.627-5.05-2.179-6.834-6.404-3.928-17.167-3.598-19.214.99-2.212-.297-3.335 1.487-3.665 3.27-5.711 1.55-.428 8.15.99 8.416 1.92.657 2.444.175 2.774-.452 1.068.263 2.533-.88 2.901-1.667 1.357.25 2.387.225 2.413-1.135 3.887 3.642 9.244 6.164 9.84 1.473l6.14-4.06z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.99}
      fill="#f7b200"
    />
    <path
      d="M271.025 236.031c-.363 2.543 1.344 5.283 4.051 7.924M274.578 232.863c-.363 2.542.363 6.866 3.07 9.508M278.6 230.135c-2.486 2.087-1.131 8.547 1.576 11.189"
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      strokeLinejoin="round"
      d="M285.247 177.325c5.737 7.598-2.285 15.992-9.295 20.829-8.264 6.5-12.727 19.169 1.847 19.947 5.263-.097 10.978-.563 14.194 3.558 3.216 4.121 3.334 11.734-4.766 16.614-.794-.701-1.974-2.79-2.853-3.427-.879-.637-1.457.18-2.25-.521-.28-2.615 3.992-6.506-.048-7.446-5.23.887-23.535.963-23.302-16.499.402-3.891 2.482-8.26 5.82-12.704 3.339-4.444 12.49-9.955 13.37-12.368 1.408-2.084-1.169-6.138-3.223-6.699-1.68-4.482 5.743-9.268 10.505-1.285z"
      fillRule="evenodd"
      stroke="#000100"
      strokeWidth={0.99}
      fill="#288800"
    />
    <path
      d="M272.497 190.769l.198 10.2M267.153 194.828l10.895 1.585M275.178 188.49l9.21 1.882"
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M265.475 196.61l7.67 4.542M260.01 206.2l5.989 6.363M265.55 197.031l1.017 15.047M261.416 203.331l9.84.2"
      strokeOpacity={0.642}
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M251.122 228.756c1.523-1.443 3.114-3.515 4.098-5.542M254.197 231.344c2.058-1.274 4.7-2.278 7.32-2.811M257.984 240.1c1.785-1.487 3.705-3.064 5.018-5.135M258.05 240.438c3.14-.077 6.326-.4 9.42-.97M263.656 246.616c2.336-.88 4.47-2.23 6.2-3.582M247.41 225.597c1.81-1.462 3.621-3.126 5.095-4.858M246.078 220.91c1.969-.529 3.892-1.529 5.57-2.462M246.762 216.025c1.593-.617 3.455-.875 5.182-.976M248.244 211.525c1.926-.19 3.224-.072 5.15.53M248.572 208.666c1.594-.856 3.386-1.413 5.178-1.179M247.775 206.547l5.55-3.79M246.8 204.981l4.727-4.685M245.46 204.335l3.463-5.916M259.269 169.366l-.043 8.43M267.8 170.706c-1.243 2.43-2.983 5.302-5.22 7.447M261.51 169.085c-2.477-.198-4.816 1.143-6.698 2.727"
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      strokeLinejoin="round"
      d="M274.71 175.516c4.115 1.514 9.579 3.595 9.01 15.681 3.406-3.69 4.968-8.869.64-15.397-2.91-3.146-7.167-3.809-9.65-.284z"
      fillRule="evenodd"
      fillOpacity={0.994}
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={0.5278124999999999}
      fill="#9d4600"
    />
    <path
      d="M276.566 179.547c.165-2.342 3.44-5.238 5.167-5.877M277.822 181.666c.863-2.993 4.594-5.369 6.32-6.007M277.906 185.903c1.594.025 7.625-3.32 9.005-5.311M278.394 183.672c1.939-1.348 5.581-4.4 7.308-5.038M283.719 186.119c1.452-.827 1.948-.624 3.47-2.19M274.71 175.581c4.138 1.349 9.2 4.4 8.869 15.61"
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M260.928 218.903l5.633-6.828M261.631 220.31l5.03-.005M258.819 213.485l7.037 4.009"
      strokeOpacity={0.642}
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M268.297 212.8c-1.347-.125-2.12-.381-3.292-.815.552 9.07 1.457 9.536 2.89 12.956 4.289 2.72 11.71 2.084 14.851 1.406.338.474 2.195 2.779 1.053 3.448-1.231.772-1.73 2.269-1.775 4.688.727.82 1.485.108 2.225.635s1.61 2.391 2.296 3.996c0 0 9.12-6.268 7.64-12.165-.97-5.54-4.715-7.426-4.715-7.426-5.295-2.647-12.738-.891-15.454-1.906-3.378-.75-5.503-3.67-5.72-4.817z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.5278124999999999}
      fill="#9d4600"
    />
    <path
      d="M283.325 228.803c4.568-2.085 9.397-2.255 10.71-2.063M265.456 216.69c.992-.58 2.451-1.819 4.132-1.793M273.856 226.685c.812-4.806 2.871-8.05 3.932-8.862M276.603 227.06c.812-4.806 3.058-8.238 4.118-9.049M279.66 226.74c.81-4.804 2.87-7.924 3.93-8.735M281.975 226.366c.811-4.805 3.495-7.176 4.555-7.988M283.503 227.735c.812-4.806 4.893-7.475 5.953-8.287M283.634 228.475c2.782-4 7.354-5.944 8.66-6.226M270.988 226.056c.81-4.805 2.932-7.425 3.993-8.237M268.24 225.185c.812-4.806 3.308-7.239 4.37-8.05M282.5 235.056c2.156-1.696 3.622 3.783 3.729 4.447.107.664.51 1.34 1.583 1.96M266.563 221.875c.873-2.434 2.808-5.116 3.869-5.928"
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M278.384 230.35c-2.798 4.445.432 8.37 4.055 6.796-.416-3.072-1.201-5.023 1.6-7.978-1.986.117-3.77-.586-5.655 1.182z"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.0518750000000001}
      fill="#fff"
    />
    <path
      d="M267.828 197.669l1.324 6.53M269.15 203.669l-2.383 8.03M283.222 229.225c4.928-.96 9.665 0 10.895.493"
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M282.64 230.013c5.052-.074 9.458 1.99 10.544 2.8"
      stroke="#000"
      strokeWidth={1.0640625}
      fill="none"
    />
    <path
      d="M282.697 230.95c4.86 1.106 7.038 3.57 7.888 4.61M282.36 232.066c4.36 2.414 5.34 4.395 5.867 5.632"
      stroke="#000"
      strokeWidth={1.0565625}
      fill="none"
    />
    <path
      fillRule="evenodd"
      strokeWidth="1pt"
      fill="#296526"
      d="M210.222 255.434l2.342-.55 2.539 10.83-2.341.548zM229.69 292.019l4.917 5.599 1.836-1.553-4.615-5.8-2.137 1.754zM379.756 315.944l-6.09 4.291 1.348 1.991 6.258-3.97-1.516-2.312zM411.884 289.15l-5.433 5.098 1.613 1.784 5.643-4.804-1.823-2.078zM429.116 253.188l-1.977 4.878 1.08 1.399 2.127-4.642-1.23-1.635z"
    />
    <path
      d="M268.175 225.447c-2.639-4.342-2.973-8.885-3.106-13.327 1.402.668 2.505 1.035 3.306.801M258.988 169.113c-2.173-5.433.335-8.376 3.045-10.955"
      stroke="#000"
      strokeWidth={0.99}
      fill="none"
    />
    <path
      d="M262.525 156.643c.457.579.179 1.628-.621 2.344-.8.715-1.82.826-2.278.247-.457-.58-.179-1.629.622-2.344.8-.716 1.82-.826 2.277-.247z"
      fillRule="evenodd"
    />
    <path
      d="M248.46 197.997c-.455 0-8.326-1.06-8.326-1.06M245.131 203.753c0-.302-5.146-6.66-5.146-6.66"
      stroke="#000"
      strokeWidth={1.2862500000000001}
      fill="none"
    />
  </SvgIcon>
)

export default React.memo(FlagMexico)
